export const SET_CURRENT_CUSTOMER = 'SET_CURRENT_CUSTOMER';
export const SET_CURRENT_PARTNER = 'SET_CURRENT_PARTNER';
